function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fork, cancel } from 'redux-saga/effects';

var createSagaManager = function createSagaManager() {
  var sagas = {};
  return {
    start: /*#__PURE__*/_regeneratorRuntime.mark(function start(key, saga) {
      var _len,
          sagaArgs,
          _key,
          sagaId,
          _args = arguments;

      return _regeneratorRuntime.wrap(function start$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!Array.isArray(sagas[key])) {
                sagas[key] = [];
              }

              for (_len = _args.length, sagaArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                sagaArgs[_key - 2] = _args[_key];
              }

              _context.next = 4;
              return fork.apply(void 0, [saga].concat(sagaArgs));

            case 4:
              sagaId = _context.sent;
              sagas[key].push(sagaId);
              return _context.abrupt("return", sagaId);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, start);
    }),
    stop: /*#__PURE__*/_regeneratorRuntime.mark(function stop(key, callback) {
      var _iterator, _step, sagaId;

      return _regeneratorRuntime.wrap(function stop$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!Array.isArray(sagas[key])) {
                _context2.next = 8;
                break;
              }

              _iterator = _createForOfIteratorHelperLoose(sagas[key]);

            case 2:
              if ((_step = _iterator()).done) {
                _context2.next = 8;
                break;
              }

              sagaId = _step.value;
              _context2.next = 6;
              return cancel(sagaId);

            case 6:
              _context2.next = 2;
              break;

            case 8:
              delete sagas[key];

              if (typeof callback === 'function') {
                callback();
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, stop);
    })
  };
};

export default createSagaManager;
//# sourceMappingURL=create-saga-manager.js.map